import React from 'react';
import styles from './PurchaseConfirmDialog.module.css';

const PurchaseConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  resource,
  userProfile,
  purchasing
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <div className={styles.header}>
          <h3>购买确认</h3>
          <button className={styles.closeBtn} onClick={onClose}>×</button>
        </div>

        <div className={styles.content}>
          <div className={styles.resourceInfo}>
            <h4>{resource.title}</h4>
            <p>资源价格: <span className={styles.price}>{resource.price} 金币</span></p>
          </div>

          <div className={styles.userInfo}>
            <div className={styles.balanceInfo}>
              <span>当前余额: <strong>{userProfile.coinBalance} 金币</strong></span>
              <span>购买后余额: <strong>{userProfile.coinBalance - resource.price} 金币</strong></span>
            </div>
          </div>

          <div className={styles.warning}>
            <p>⚠️ 购买后金币将立即扣除，请确认您要购买此资源</p>
          </div>
        </div>

        <div className={styles.actions}>
          <button
            className={styles.cancelBtn}
            onClick={onClose}
            disabled={purchasing}
          >
            取消
          </button>
          <button
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={purchasing}
          >
            {purchasing ? '购买中...' : '确认购买'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseConfirmDialog;